import { SyncAPICommandDispatcher } from "@/modules/shared/infra/APICommandDispatcher";
import { APIQueryDispatcher,APIQueryDispatcherGET, APIQueryDispatcherAbort } from "@/modules/shared/infra/APIQueryDispatcher";
import {AsyncAPICommandDispatcher} from "@/modules/shared/infra/APIAsyncCommandDispatcher";
import axios from "axios";
import { DocumentComponentsFactory } from "@/modules/document/infra/DocumentComponentsFactory";

// const CSRF_COOKIE_NAME = "csrftoken";
// const CSRF_HEADER_NAME = "X-CSRFToken";

//const baseURL = "https://api.inmatic.ai/api";
//const baseURL = "/api";
const baseURL = process.env.VUE_APP_API_ENDPOINT;

let client;
let sync_command_dispatcher;
let async_command_dispatcher;
let query_dispatcher;
let query_dispatcher_get;
let query_dispatcher_abort;

let document_components_factory;
function setHeaders(headers){
  client = axios.create({
    baseURL, headers,
    // xsrfCookieName: CSRF_COOKIE_NAME,
    // xsrfHeaderName: CSRF_HEADER_NAME
    
  });
  sync_command_dispatcher = new SyncAPICommandDispatcher()
  async_command_dispatcher = new AsyncAPICommandDispatcher()
  query_dispatcher = new APIQueryDispatcher()
  query_dispatcher_get = new APIQueryDispatcherGET()
  query_dispatcher_abort = new APIQueryDispatcherAbort()
  document_components_factory = new DocumentComponentsFactory();
}

export {
  client,
  setHeaders,
  sync_command_dispatcher,
  async_command_dispatcher,
  query_dispatcher,
  query_dispatcher_get,
  query_dispatcher_abort,
  document_components_factory
};